import { normalizeApiError } from "../../../shared/errors/normalizeApiError";
import { httpClient } from "../../../shared/api/httpClient";
import { Item, OrdersResponse } from "../model/orders.api";
import { OrderCreateRequest } from "../model/orderCreate.api";
import { OrderUpdateRequest, OrderUpdateResponse } from "../model/orderUpdate.api";
import { OrderDetailResponse } from "../model/orderDetail.api";

const normalizeFailure = (error: unknown): never => {
    throw normalizeApiError(error);
};

export const orderApi = {

    async getListOrder(
        page: number,
        pageSize: number,
        search?: string,
        status?: string,
        createdFrom?: string,
        createdTo?: string
    ): Promise<OrdersResponse> {
        try {
            const params: Record<string, unknown> = {
                page,
                page_size: pageSize,
                include_deleted: false,
                sort_by: "created_at",
                sort_dir: "desc",
            };
            if (search) params.search = search;
            if (status) params.status = status;
            if (createdFrom) params.created_from = createdFrom;
            if (createdTo && (!createdFrom || createdTo > createdFrom)) params.created_to = createdTo;
            const response = await httpClient.get<OrdersResponse>("/orders", {
                params,
            });
            return response.data;
        }
        catch (error) {
            return normalizeFailure(error);
        }
    },
    async getOrderById(orderId: number): Promise<OrderDetailResponse> {
        try {
            const response = await httpClient.get<OrderDetailResponse>(`/orders/${orderId}`);
            return response.data;
        } catch (error) {
            return normalizeFailure(error);
        }
    },
    async createOrder(payload: OrderCreateRequest): Promise<Item> {
        try {
            const response = await httpClient.post<Item>("/orders", payload);
            return response.data;
        } catch (error) {
            return normalizeFailure(error);
        }
    },
    async updateOrder(orderId: number, payload: OrderUpdateRequest): Promise<boolean> {
        try {
            await httpClient.put<OrderUpdateResponse>(`/orders/${orderId}`, payload);
            return true;
        } catch (error) {
            return normalizeFailure(error);
        }
    },
    async deleteOrder(orderId: number): Promise<void> {
        try {
            await httpClient.delete(`/orders/${orderId}`);
        } catch (error) {
            return normalizeFailure(error);
        }
    },
} 